import React from "react";
import pluralize from "pluralize";
import { formatNumber } from "../../../../../utils/constants/constants";
import { isAdvancedCashback } from "../../../Private/Loyalty/Edit/utils";
import LoyaltyFinalCreative from "../../../Private/Loyalty/Edit/components/LandingPages/LoyaltyFinalCreative";
import AdvancedLoyaltyFinalCreative from "../../../Private/Loyalty/Edit/components/LandingPages/AdvancedLoyaltyFinalCreative";

const LockedLoyaltyCard = ({
  loyaltyData,
  pointsObj,
  storeName,
  currencyView,
}) => {
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const redeemableRewards = loyaltyData?.rewards?.filter(
    (reward) =>
      reward?.is_active && reward?.points_value <= pointsObj?.current_points
  )?.length;
  const nonRedeemableRewards = loyaltyData?.rewards?.filter(
    (reward) =>
      reward?.is_active && reward?.points_value > pointsObj?.current_points
  );
  const isAdvCbCreative =
    loyaltyData?.type === "cashback" &&
    isAdvancedCashback(loyaltyData?.settings?.advanced_cashback?.type);

  const reqPointsForNxtReward =
    nonRedeemableRewards?.[0]?.points_value - pointsObj?.current_points;
  let reqValForNxtReward = formatNumber(
    (reqPointsForNxtReward * loyaltyData.amount_spent) /
      loyaltyData.points_earned
  );

  reqValForNxtReward =
    reqValForNxtReward < loyaltyData.amount_spent
      ? loyaltyData.amount_spent
      : Math.ceil(reqValForNxtReward / loyaltyData.amount_spent) *
        loyaltyData.amount_spent;

  let txtForNxtReward;
  if (loyaltyData?.type === "amount_spent") {
    txtForNxtReward =
      reqValForNxtReward > 0
        ? `Spend ${currencyView}${reqValForNxtReward.toFixed(
            0
          )} to unlock the next reward`
        : "";
  } else if (loyaltyData?.type === "visit_made") {
    txtForNxtReward =
      reqValForNxtReward > 0
        ? `You're ${reqValForNxtReward.toFixed(
            0
          )} visit away to unlock the next reward`
        : "";
  }

  return (
    <div className="shortlink-loyalty-div">
      <h6>Loyalty rewards</h6>
      {loyaltyData?.type === "cashback" ? (
        <div className="cash-rewards-div">
          <span>
            {pointsBranding?.active
              ? `${pointsObj?.current_points || 0} ${pluralize(
                  pointsBranding?.name,
                  pointsObj?.current_points || 0
                )} to spend 🎉`
              : `${currencyView}${
                  pointsObj?.current_points || 0
                } Cash to spend 🎉`}
          </span>
        </div>
      ) : (
        <>
          <div
            className="show-total-rewards"
            style={txtForNxtReward ? {} : { paddingBottom: "24px" }}
          >
            <img src="/assets/icons/unlocked.svg" alt="unlock" />
            <span>
              {redeemableRewards} {pluralize("Rewards", redeemableRewards)}{" "}
              Unlocked 🎉
            </span>
          </div>
          {txtForNxtReward && (
            <div className="next-rewards-div">
              <img src="/assets/icons/lightning.svg" alt="lightning" />
              <span>{txtForNxtReward}</span>
            </div>
          )}
        </>
      )}
      {isAdvCbCreative ? (
        <AdvancedLoyaltyFinalCreative
          isShortlink={true}
          pointsObj={pointsObj}
          storeName={storeName}
          loyaltyData={loyaltyData}
        />
      ) : (
        <LoyaltyFinalCreative
          isShortlink={true}
          pointsObj={pointsObj}
          storeName={storeName}
          loyaltyData={loyaltyData}
        />
      )}
    </div>
  );
};

export default LockedLoyaltyCard;
